import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { PAWorkFlowModel } from "@/store/models/paWorkFlow/paWorkFlowDTO";
let WorkflowDetailViewComponent = /** @class */ (() => {
    var _a;
    let WorkflowDetailViewComponent = class WorkflowDetailViewComponent extends Mixins(BaseMixer) {
        showModal() {
            this.$bvModal.show("view-workflow");
        }
        closeWorkflow() {
            this.$bvModal.hide("view-workflow");
            this.$emit("cancel-workflow");
        }
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], WorkflowDetailViewComponent.prototype, "createdOn", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PAWorkFlowModel !== "undefined" && PAWorkFlowModel) === "function" ? _a : Object)
    ], WorkflowDetailViewComponent.prototype, "workflow", void 0);
    WorkflowDetailViewComponent = __decorate([
        Component({
            name: "WorkflowDetailViewComponent",
        })
    ], WorkflowDetailViewComponent);
    return WorkflowDetailViewComponent;
})();
export default WorkflowDetailViewComponent;
